document.addEventListener("DOMContentLoaded", function () {

  const form = document.querySelector('[data-template-contact] form');
  const nameInput = document.getElementById("contact_name");
  const emailInput = document.getElementById("contact_email");
  const messageInput = document.getElementById("contact_message");

  const errorName = document.getElementById("error-name");
  const errorEmail = document.getElementById("error-email");
  const errorMessage = document.getElementById("error-message");

  form.addEventListener("submit", function (e) {

    let hasError = false;

    // Clear old errors
    errorName.textContent = "";
    errorEmail.textContent = "";
    errorMessage.textContent = "";

    nameInput.classList.remove("form-field-error");
    emailInput.classList.remove("form-field-error");
    messageInput.classList.remove("form-field-error");

    // validations
    if (nameInput.value.trim() === "") {
      errorName.textContent = "Name is required.";
      nameInput.classList.add("form-field-error");
      hasError = true;
    }

    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (emailInput.value.trim() === "") {
      errorEmail.textContent = "Email is required.";
      emailInput.classList.add("form-field-error");
      hasError = true;
    } else if (!emailPattern.test(emailInput.value.trim())) {
      errorEmail.textContent = "Please enter a valid email address.";
      emailInput.classList.add("form-field-error");
      hasError = true;
    }
    
    if (messageInput.value.trim() === "") {
      errorMessage.textContent = "Message is required.";
      messageInput.classList.add("form-field-error");
      hasError = true;
    }

    // if (hasError) {
    //   e.preventDefault();
    // } else {
    //   const productName = "{{ product.title | escape }}";
    //   messageInput.value += "\n\nProduct: " + productName;
    // }
    if (hasError) {
      e.preventDefault();
    }

  });

});